export default "__VITE_PUBLIC_ASSET__959a59a9__"